import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'
import type { AxiosResponse } from 'axios'
import type { FlowActionsPaymentResponse } from '@/types'
import type { PaymentId } from '@/types/payment'

export default {
  get(paymentId: PaymentId): Promise<AxiosResponse<FlowActionsPaymentResponse>> {
    return http.get(endpoints.get('flowActionsPayment', { paymentId }))
  }
}
